import { makeStyles, Typography } from '@material-ui/core'
import React from 'react'

import { Footer, Header } from 'components'

const useStyles = makeStyles(theme => ({
    root: {
        padding: 50,
        [theme.breakpoints.down('sm')]: {
            padding: 20
        }
    },
    text: {
        textAlign: ({ center }) => center && 'center',
        marginBottom: 20,
        [theme.breakpoints.down('sm')]: {
            fontSize: 'small'
        }
    }
}))

function Text({ children, center }) {
    const classes = useStyles({ center })
    return <Typography className={classes.text}>{children}</Typography>
}

function ListItem({ children }) {
    const classes = useStyles()
    return (
        <ul>
            <li>
                <Typography className={classes.text}> {children}</Typography>
            </li>
        </ul>
    )
}
export default function TermsOfUse() {
    const classes = useStyles()

    return (
        <>
            <div className={classes.root}>
                <Text center>
                    <strong> LOVEPLATES TERMS OF SERVICE </strong>
                </Text>
                <Text center>Last Updated: February 2022</Text>
                <Text>
                    Please read these Terms of Service (&ldquo;Agreement&rdquo; or &ldquo;Terms&rdquo;)
                    carefully. Your use or access of the App (as defined below)
                    constitutes your consent to this Agreement.
                </Text>
                <Text>
                    This Agreement is between you and LovePlates LLC
                    (&ldquo;LovePlates&rdquo;, &ldquo;we&rdquo;, &ldquo;our&rdquo; or &ldquo;us&rdquo;) concerning your use of
                    (including any access to) LovePlates&rsquo; mobile applications,
                    web applications, and website (collectively with any other
                    materials and services available therein, and successor
                    application(s) or websites thereto, &ldquo;App&rdquo;) and the services
                    we provide via the App (&ldquo;Services&rdquo;).
                </Text>
                <Text>
                    By clicking or tapping any button or box marked &ldquo;accept,&rdquo;
                    &ldquo;agree&rdquo; or &ldquo;OK&rdquo; (or a similar term) in connection with this
                    Agreement, or by accessing or using the App, you agree to be
                    bound by this Agreement and affirm that you are of legal age
                    to enter into this Agreement where you live and have the
                    legal capacity to enter into this Agreement.
                </Text>
                <Text>
                    <strong> User Accounts</strong>
                </Text>
                <Text>
                    While you may always browse public-facing portions of the
                    App without registering an account with us, in order to
                    access certain portions of the App or Services, LovePlates
                    may require you to register an account with us (&ldquo;Account&rdquo;).
                </Text>
                <Text>
                    You are responsible for the security of your Account, and
                    are fully responsible for all activities that occur through
                    the use of your credentials including your username and
                    password. You agree to notify us immediately if you suspect
                    or know of any unauthorized use of your log-in credentials
                    or any other breach of security with respect to your
                    Account. We will not be liable for any loss or damage
                    arising from unauthorized use of your credentials. You may
                    be required to create and provide separate log-in
                    credentials to access Third-Party Services.
                </Text>
                <Text>
                    When you create an Account or claiming your business&#39;
                    listing, you represent to LovePlates that all information
                    provided to us is true, accurate, and correct, and that you
                    will promptly update your information as needed in order to
                    keep it accurate. If you are claiming a business listing,
                    then you represent to us that you are the owner or
                    authorized agent of such business. You may not impersonate
                    another person or create an account for anyone other than
                    yourself. You are prohibited from (a) creating multiple
                    accounts or business listings; and (b) providing or using
                    false information to obtain access to a business&#39;
                    listing on the Services that you are not legally entitled to
                    claim.
                </Text>
                <Text>
                    We reserve the right to disallow, cancel, remove, or
                    reassign certain usernames and other information associated
                    with an Account in appropriate circumstances, as determined
                    by us in our sole and absolute discretion, and may, with or
                    without prior notice, suspend or terminate your Account if
                    activities occur on your Account which would or might
                    constitute a violation of this Agreement, cause damage to or
                    impair the Services or App, infringe or violate any
                    third-party rights, damage or bring into disrepute the
                    reputation of LovePlates, or violate applicable law. These
                    determinations will be made in LovePlates&rsquo; sole and absolute
                    discretion. If messages sent to the email address you
                    provide are returned as undeliverable, then we may terminate
                    your Account immediately without notice to you and without
                    any liability to you or any third-party.
                </Text>
                <Text>
                    <strong>Service Availability and Mobile Services</strong>
                </Text>
                <Text>
                    The App and Services may be modified, updated, interrupted,
                    suspended or discontinued at any time without notice or
                    liability.
                </Text>
                <Text>
                    The App and Services or portions thereof may be accessible
                    via a mobile phone, tablet or other wireless devices
                    (collectively, &ldquo;Mobile Services&rdquo;). Your mobile carrier&rsquo;s
                    normal messaging, data and other rates and fees will apply
                    to your use of the Mobile Services. In addition,
                    downloading, installing or using certain Mobile Services may
                    be prohibited or restricted by your mobile carrier, and not
                    all Mobile Services may work with all carriers or devices.
                    Therefore, you are solely responsible for checking with your
                    mobile carrier to determine if the Mobile Services are
                    available for your mobile device(s), what restrictions, if
                    any, may be applicable to your use of the Mobile Services,
                    and how much they will cost you. Nevertheless, all use of
                    the App and the related Mobile Services must be in
                    accordance with this Agreement. LovePlates shall not be
                    liable to any party for any loss or damage resulting in
                    whole or in part from any malfunction in its App or Service
                    to you to the extent such malfunction arises from, or is in
                    anyway connected to, your mobile carrier&rsquo;s service.
                </Text>
                <Text>
                    <strong>Communications </strong>
                </Text>
                <Text>
                    By accessing or using the App and Services, you consent to
                    receive communications from other users and LovePlates
                    through the App and Services or through any other means such
                    as emails, push notifications, text messages (including SMS
                    and MMS), and phone calls. You acknowledge that these
                    communications may advertise and promote LovePlates or
                    businesses listed on LovePlates. You further acknowledge
                    that these communications may be initiated by LovePlates,
                    businesses listed on LovePlates, or other users. You also
                    acknowledge that communications may be sent using an
                    automatic telephone dialing system, and that you may be
                    charged by your phone carrier for certain communications
                    such as SMS or MMS messages or phone calls. By accessing or
                    using the App and Services, you agree to notify us
                    immediately if the phone number(s) you have provided to us
                    have been changed or disconnected.
                </Text>
                <Text>
                    <strong> Intellectual Property Rights </strong>
                </Text>
                <Text>
                    The App, Services, and their entire contents, features, and
                    functionality (including but not limited to all information,
                    software, text, displays, images, video, and audio, and the
                    design, selection, and arrangement thereof), are owned by
                    LovePlates, its licensors, or other providers of such
                    material and are protected by United States and
                    international copyright, trademark, patent, trade secret,
                    and other intellectual property or proprietary rights laws.
                    LovePlates grants you a revocable, non-exclusive, non-transferable,
                    non-sublicensable, royalty-free and worldwide
                    right and license to access and use the Services and App
                    solely in strict compliance with the provisions of this
                    Agreement and as permitted by the functionalities of the App
                    and Services available to you.
                </Text>
                <Text>
                    LovePlates&rsquo; name and all related names, logos, product and
                    service names, designs, and slogans are trademarks of
                    LovePlates, its affiliates, or licensors. You must not use
                    such marks without the prior written permission of
                    LovePlates. All other names, logos, product and service
                    names, designs, and slogans on this App are the trademarks
                    of their respective owners.
                </Text>
                <Text>
                    LovePlates reserves all rights not expressly granted to you
                    in this section. Accordingly, nothing in this Agreement or
                    on the App or Services will be construed as granting to you,
                    by implication, estoppel or otherwise, any additional
                    license rights in and to the App, Services, or any
                    LovePlates intellectual property located or displayed on or
                    within the App or Services.
                </Text>
                <Text>
                    <strong>Recipes</strong>
                </Text>
                <Text>
                    LovePlates may post recipes for users to view, use, and
                    download as in-app downloads and purchases (“Recipes”).
                    Recipes are created by LovePlates and our affiliated
                    partners and chefs. We own all intellectual property rights
                    to all Recipes and any unauthorized republication or
                    commercial use is strictly prohibited whether the Recipe is
                    offered for free or purchase. You may not copy, publicly
                    display, reproduce, distribute, modify, translate, remove,
                    analyze, commercialize, prepare derivative works of,
                    publish, display, or otherwise distribute any Recipes that
                    are offered by LovePlates.
                </Text>
                <Text>
                    <strong>Content and Reviews</strong>
                </Text>
                <Text>
                    Certain features on the App may allow you to submit, post,
                    or upload (collectively, &ldquo;Post&rdquo;) content to the App or you
                    may otherwise directly or indirectly provide content to
                    LovePlates, such as user profile content or other materials
                    subject to intellectual property or similar applicable law
                    (&ldquo;User Content&rdquo;). You acknowledge and agree that you alone
                    are responsible for your User Content. You may not be able
                    to edit or delete User Content. You assume all risks
                    associated with your User Content, including anyone&rsquo;s
                    reliance on its quality, accuracy, or reliability, and any
                    risks associated with any personal information you disclose
                    through the App or Services. You represent that you own or
                    have the necessary rights to use and authorize the use of
                    your User Content as described herein. You may not imply
                    that your User Content is in any way sponsored or endorsed
                    by LovePlates. For all User Content that you Post, you grant
                    us (and those third parties we work with) a worldwide,
                    perpetual, non-exclusive, royalty-free, assignable,
                    sublicensable, transferable license to use, copy, publicly
                    perform and display, reproduce, distribute, modify,
                    translate, remove, analyze, commercialize, and prepare
                    derivative works of (such as those resulting from changes we
                    make so that your User Content works better with our App),
                    publish, display, and distribute such content; provided that
                    we will not share with other users any User Content that you
                    Post that is not viewable by other users based on any
                    privacy settings available on the App. The rights you grant
                    in this section are for the purpose of operating, promoting,
                    and improving our App and Services and this license
                    continues even if you stop using our App.
                </Text>
                <Text>
                    We are under no obligation to edit or control User Content
                    that you Post, and will not be in any way responsible or
                    liable for User Content. LovePlates may, however, at any
                    time and without prior notice, filter, screen, remove, edit,
                    or block any User Content that, in our sole and absolute
                    discretion, violates this Agreement or is otherwise
                    objectionable. User Content that LovePlates determines is or
                    could be interpreted to be abusive, bigoted, defamatory,
                    harassing, harmful, infringing, obscene, offensive,
                    pornographic, racist, threatening, unlawful, vulgar or
                    otherwise inappropriate (collectively, &ldquo;Offensive Content&rdquo;)
                    may be screened, removed, edited, or blocked. Further, we
                    may take any action we deem necessary and/or appropriate
                    against any user who Posts Offensive Content, including, but
                    not limited to, suspending or terminating the user&rsquo;s
                    Account.
                </Text>
                <Text>
                    Reviews or ratings for businesses listed on LovePlates do
                    not reflect the opinion of LovePlates. We provide a platform
                    where reviews or ratings for businesses are made by Users,
                    which reflect the opinions of such Users. LovePlates is a
                    neutral platform, which solely provides a means of
                    communication between Users and businesses.
                </Text>
                <Text>
                    <strong>
                        Reservations, Appointments, Booking, Transactions
                    </strong>
                </Text>
                <Text>
                    LovePlates may provide you with access to features that
                    allow you to make reservations, scheduling an appointment,
                    or complete an online transaction with local businesses or
                    service providers, such as making restaurant or hotel
                    reservations, or ordering food delivery. These Services and features
                    may be provided by LovePlates or by our third-party partners.
                    Any use of third-party partners shall be governed by additional terms
                    presented to you as part of the reservation, scheduling, or
                    transaction process. LovePlates is not responsible for
                    fulfilling any reservations, appointments, bookings, or
                    transactions made by you with a third-party partner.
                </Text>
                <Text>
                    As part of the process of making a reservation, appointment,
                    or transaction, you may be required to provide payment
                    information, including credit card information, to confirm a
                    reservation. You understand that you may be charged
                    additional fees, including cancellation or no-show fees in
                    accordance with the third-party local business&rsquo;s policies.
                </Text>
                <Text>
                    <strong>Acceptable Use</strong>
                </Text>
                <Text>
                    In connection with the use of the App or Services, you must
                    not:
                </Text>
                <ListItem>
                    Post, transmit or otherwise make available through or in
                    connection with the App or Services any materials that are
                    or may be: (i) threatening, harassing, degrading, hateful or
                    intimidating, or otherwise fail to respect the rights and
                    dignity of others; (ii) defamatory, libelous, fraudulent or
                    otherwise tortious; (iii) obscene, indecent, pornographic or
                    otherwise objectionable; or (iv) protected by copyright,
                    trademark, trade secret, right of publicity or privacy or
                    any other proprietary right, without the express prior
                    written consent of the applicable owner.
                </ListItem>
                <ListItem>
                    Post any fake or defamatory review, trade reviews with
                    others, or compensate someone or be compensated to post,
                    refrain from posting, or remove a review.
                </ListItem>
                <ListItem>
                    Threaten, stalk, harm, or harass others, or promote bigotry
                    or discrimination.
                </ListItem>
                <ListItem>
                    Delete or alter any content or material that LovePlates
                    makes available on the App and/or Services.
                </ListItem>
                <ListItem>
                    Remove any copyright, trademark or other proprietary rights
                    notice from the App or Services.
                </ListItem>
                <ListItem>Violate any applicable law.</ListItem>
                <ListItem>
                    Post, transmit or otherwise make available through or in
                    connection with the App or Services any virus, worm, Trojan
                    horse, Easter egg, time bomb, spyware, ransomware, malware,
                    or other computer code, file or program that is or is
                    potentially harmful or invasive or intended to damage or
                    hijack the operation of, or to monitor the use of, any
                    hardware, software or equipment.
                </ListItem>
                <ListItem>
                    Systematically download and store content from the App or
                    Services.
                </ListItem>
                <ListItem>
                    Record, process, or mine information about users.
                </ListItem>
                <ListItem>
                    Access, retrieve or index any portion of the App or Services
                    for purposes of constructing or populating a searchable
                    database of business reviews.
                </ListItem>
                <ListItem>
                    Reverse engineer, decipher, decompile or disassemble any
                    portion of the App, except to the extent such restriction is
                    expressly prohibited by applicable law.
                </ListItem>
                <ListItem>
                    Use the App to transmit through or in connection with the
                    App, any spam, chain letters or other unsolicited
                    communications. Interfere with or disrupt the operation of
                    the App or the servers or networks used to make the App or
                    Services available, including by hacking or defacing any
                    portion of the App (including any content available
                    thereby); or violate any requirement, procedure or policy of
                    such servers or networks.
                </ListItem>
                <ListItem>
                    Restrict or inhibit any other person from legal use of the
                    App or Services.
                </ListItem>
                <ListItem>
                    Reproduce, modify, adapt, translate, create derivative works
                    of, sell, rent, lease, loan, timeshare, distribute or
                    otherwise exploit any portion of (or any use of) the App or
                    Services except as expressly authorized herein, without
                    LovePlates&rsquo; express prior written consent.
                </ListItem>
                <ListItem>
                    Frame or mirror any portion of the App or Services, or
                    otherwise incorporate any portion of the App into any
                    product or service, without LovePlates&rsquo; express prior
                    written consent.
                </ListItem>
                <ListItem>
                    Restrict, discourage or inhibit any person from using the
                    App or Services.
                </ListItem>
                <ListItem>
                    Use any robot, spider, App search/retrieval application or
                    other manual or automatic device to retrieve, index,
                    &ldquo;scrape,&rdquo; &ldquo;data mine&rdquo;, or otherwise gather content on the
                    App or Services (including Submissions), or reproduce or
                    circumvent the navigational structure or presentation of the
                    App, without LovePlates&rsquo; express prior written consent.
                    Notwithstanding the foregoing, and subject to compliance
                    with applicable law and any instructions posted in the
                    robots.txt file located in the App&rsquo;s root directory,
                    LovePlates grants to the operators of public search engines
                    permission to use spiders to copy materials from the App for
                    the sole purpose of (and solely to the extent necessary for)
                    creating publicly available, searchable indices of such
                    materials, but not caches or archives of such materials.
                    LovePlates reserves the right to revoke such permission
                    either generally or in specific cases, at any time and
                    without notice.
                </ListItem>
                <ListItem>
                    Create a false identity or impersonate another person or
                    entity in any way.
                </ListItem>
                <Text>
                    <strong>Privacy</strong>
                </Text>
                <Text>
                    All information we collect on this App is subject to our
                    Privacy Policy. By using the App, you consent to all actions
                    taken by us with respect to your information in compliance
                    with our Privacy Policy.
                </Text>
                <Text>
                    Our Privacy Policy is a part of this Agreement. Please
                    review our Privacy Policy, which also governs the App and
                    informs users of our data collection practices.
                </Text>
                <Text>
                    Please note that it is our policy to comply with all
                    facially valid subpoenas, court orders or binding orders
                    issued to us by law enforcement agencies and other
                    government authorities. This may affect your access to your
                    account, your funds and our services to you. We are not
                    responsible for any losses, whether direct or indirect, that
                    you may incur as a result of our compliance with all
                    applicable laws, the guidance or direction of any regulatory
                    authority or government authority, or any writ of
                    attachment, lien, levy, subpoena, warrant, or other legal
                    order.
                </Text>
                <Text>
                    <strong>Third-Party Services</strong>
                </Text>
                <Text>
                    LovePlates and its affiliates may contract with
                    third-parties, including those providing research analysis
                    or other information related to the Services to provide
                    certain data, information, insights, analysis, and articles
                    that are made available through the App and the Services,
                    and may also provide links to third-party webApps (or other
                    online properties that are not owned or controlled by
                    LovePlates) or services that are not under the control of
                    LovePlates (collectively, &ldquo;Third-Party Services&rdquo;). In
                    addition to this Agreement, you may be bound by any
                    additional terms required by providers of Third-Party
                    Services. LovePlates and its affiliates make no
                    representations about, and accept no liability for, any
                    Third-Party Services.
                </Text>
                <Text>
                    <strong>Comments and Questions</strong>
                </Text>
                <Text>
                    If you choose to provide us with input or suggestions
                    regarding problems with or proposed modifications or
                    improvements to the App or Services (&ldquo;Feedback&rdquo;), then you
                    grant to us a non-exclusive, royalty-free, perpetual,
                    irrevocable, transferable, sublicensable, and global right
                    to use and exploit the Feedback in any manner and for any
                    purpose without any restriction, credit, attribution, or
                    fees due to you.
                </Text>
                <Text>
                    <strong>Limitation of Liability</strong>
                </Text>
                <Text>
                    TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL
                    LOVEPLATES, ITS AFFILIATES, OR THEIR LICENSORS, SERVICE
                    PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE
                    LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY,
                    ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY
                    TO USE, THE APP, ANY WEBAPPS LINKED TO IT, ANY CONTENT ON
                    THE APP OR SUCH OTHER WEBAPPS, OR THE SERVICES, INCLUDING
                    ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR
                    PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL
                    INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF
                    REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED
                    SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND
                    WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF
                    CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE. NOTWITHSTANDING
                    ANYTHING TO THE CONTRARY IN THESE TERMS, NOTHING IN THESE
                    TERMS EXCLUDES OR LIMITS LIABILITY FOR FRAUD, FRAUDULENT
                    MISREPRESENTATION, OR FOR DEATH OR PERSONAL INJURY CAUSED BY
                    GROSS NEGLIGENCE.
                </Text>
                <Text>
                    THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE
                    EXCLUDED OR LIMITED UNDER ALL APPLICABLE LAWS.
                </Text>
                <Text>
                    <strong>Disclaimer of Warranties</strong>
                </Text>
                <Text>
                    We have put in a great deal of effort to provide the App and
                    Services to you. We hope you find them valuable, but there
                    are certain things we can&rsquo;t promise about them.
                </Text>
                <Text>
                    YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT YOUR ACCESS TO AND
                    USE OF THE APP, SERVICES, AND ANY CONTENT IS AT YOUR SOLE
                    RISK. OTHER THAN AS EXPRESSLY SET OUT IN THESE TERMS,
                    NEITHER LOVEPLATES NOR ITS AFFILIATES MAKE ANY WARRANTY,
                    EITHER EXPRESS OR IMPLIED, ABOUT THE APP OR APP CONTENT. THE
                    APP AND APP CONTENT ARE PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS
                    AVAILABLE&rdquo; BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER
                    EXPRESS OR IMPLIED. NEITHER LOVEPLATES NOR ITS AFFILIATES
                    MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE
                    COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY, OR
                    AVAILABILITY OF THE APP OR SERVICES. WITHOUT LIMITING THE
                    FOREGOING, LOVEPLATES AND ITS AFFILIATES DO NOT REPRESENT OR
                    WARRANT THAT THE APP, ITS CONTENT, OR ANY SERVICES OR ITEMS
                    OBTAINED THROUGH THE APP WILL BE ACCURATE, RELIABLE,
                    ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS WILL BE
                    CORRECTED, THAT OUR APP, SERVICES, OR THE SERVER THAT MAKES
                    THEM AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL
                    COMPONENTS, OR THAT THE APP OR ANY SERVICES OR ITEMS
                    OBTAINED THROUGH THE APP WILL OTHERWISE MEET YOUR NEEDS OR
                    EXPECTATIONS.
                </Text>
                <Text>
                    TO THE MAXIMUM EXTENT PERMITTED BY LAW, LOVEPLATES AND ITS
                    AFFILIATES ALSO DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER
                    EXPRESS OR IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT
                    NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, FITNESS
                    FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
                </Text>
                <Text>
                    SOME STATES OR JURISDICTIONS DO NOT ALLOW THE DISCLAIMER OF
                    IMPLIED WARRANTIES, SO SOME DISCLAIMERS IN THIS SECTION MAY
                    NOT APPLY TO YOU.
                </Text>
                <Text>
                    <strong>Indemnification</strong>
                </Text>
                <Text>
                    You agree to defend, indemnify and hold harmless LovePlates,
                    its affiliates, licensors, and service providers, and their
                    respective officers, directors, employees, contractors,
                    agents, licensors, suppliers, successors and assigns from
                    and against any claims, liabilities, damages, judgments,
                    awards, losses, costs, expenses or fees (including
                    reasonable attorneys&#39; fees) arising out of or relating to
                    your violation of this Agreement or your use of the App,
                    including, but not limited to any use of the App&apos;s content,
                    services and products other than as expressly authorized in
                    this Agreement or your use of any information obtained from
                    the App.
                </Text>
                <Text>
                    <strong>Term</strong>
                </Text>
                <Text>
                    The term of this Agreement commences on your first use of
                    the App or Services and continues until the termination of
                    this Agreement by either you or LovePlates.
                </Text>
                <Text>
                    <strong>Termination and Suspension</strong>
                </Text>
                <Text>
                    These Terms are effective until terminated by us.
                    LovePlates, in its sole discretion, has the right to
                    terminate your access to the App or Services, or any part
                    thereof, immediately at any time. We reserve the right, in
                    our sole and absolute discretion, to restrict, suspend, or
                    terminate your access to all or any part of the App or
                    Service, or to terminate this Agreement at any time without
                    prior notice or liability if you breach any provision of
                    this Agreement or violate the rights of any third-party on
                    or through the App. We reserve the right to change, suspend,
                    or discontinue all or any part of the App at any time
                    without prior notice or liability.
                </Text>
                <Text>
                    LovePlates is not liable to you or any third-party for
                    termination of your access to the App or Services, or any
                    part thereof. If you object to any of the requirements,
                    statements, or obligations of these Terms, or any subsequent
                    modifications thereto, or become dissatisfied with the App
                    or Services in any way, your only recourse is to immediately
                    discontinue use of the App and/or Services. Upon termination
                    of these Terms, you will cease all use of the App and
                    Services.
                </Text>
                <Text>
                    You may terminate this Agreement by sending written
                    notification to us at contact@loveplates.com and terminating
                    your use of the App and Services.
                </Text>
                <Text>
                    <strong>Relationship of the Parties</strong>
                </Text>
                <Text>
                    You agree that no joint venture, partnership, employment or
                    agency relationship exists between you and LovePlates as a
                    result of this Agreement or use of the App or Services.
                </Text>
                <Text>
                    <strong>Governing Law and Venue</strong>
                </Text>
                <Text>
                    This Agreement and your access to and use of the App will be
                    governed by the laws of the State of California, without
                    regard to conflict of law rules or principles that would
                    cause the application of the laws of any other jurisdiction.
                    Any dispute between the parties that is not subject to
                    arbitration or cannot be heard in small claims court will be
                    resolved in the state or federal courts of the State of
                    California and the United States, respectively, sitting in
                    Los Angeles, California.
                </Text>
                <Text>
                    <strong>Dispute Resolution</strong>
                </Text>
                <Text>
                    Except as otherwise set forth in this Agreement, any
                    controversy or claim arising out of or relating to this
                    Agreement or the interpretation, breach, termination or
                    validity hereof will be resolved through arbitration in
                    accordance with the American Arbitration Association. The
                    language to be used in the arbitral proceedings will be
                    English and arbitration will take place in San Francisco,
                    California.
                </Text>
                <Text>
                    <strong>Changes to this Agreement</strong>
                </Text>
                <Text>
                    We reserve the right to change this Agreement at any time
                    upon notice. We may give notice by posting the updated
                    Agreement on the App or by any other reasonable means. You
                    can review the most current version of this Agreement at any
                    time. This Agreement in effect at the time of your use of
                    the App apply. Updated versions of the Agreement are binding
                    on you with respect to your use of the App on or after the
                    date indicated in the updated Agreement. If you do not agree
                    to the updated Agreement, you must stop using the App. Your
                    continued use of the App after the date of the updated
                    Agreement will constitute your acceptance of the updated
                    Agreement.
                </Text>
                <Text>
                    <strong>Entire Agreement</strong>
                </Text>
                <Text>
                    This Agreement and the Privacy Policy constitute the sole
                    and entire agreement between you and LovePlates with respect
                    to the App and supersede all prior and contemporaneous
                    understandings, agreements, representations and warranties,
                    both written and oral, with respect to the App. This
                    Agreement does not, and will not be construed to, create any
                    partnership, joint venture, employer-employee, agency or
                    franchisor-franchisee relationship between you and
                    LovePlates.
                </Text>
                <Text>
                    <strong>Waiver and Severability</strong>
                </Text>
                <Text>
                    No waiver of by LovePlates of any term or condition set out
                    in these Terms will be deemed a further or continuing waiver
                    of such term or condition or a waiver of any other term or
                    condition, and any failure of LovePlates to assert a right
                    or provision under these Terms will not constitute a waiver
                    of such right or provision.
                </Text>
                <Text>
                    If any provision of these Terms is held by a court or other
                    tribunal of competent jurisdiction to be invalid, illegal or
                    unenforceable for any reason, such provision will be
                    eliminated or limited to the minimum extent such that the
                    remaining provisions of the Terms will continue in full
                    force and effect.
                </Text>
                <Text>
                    <strong>Assignment</strong>
                </Text>
                <Text>
                    This Agreement will inure to the benefit of our successors
                    and assigns. You may not assign this Agreement or any of the
                    rights or licenses granted hereunder without the prior
                    express written consent of LovePlates. LovePlates may assign
                    this Agreement, including all its rights hereunder, without
                    restriction.
                </Text>
                <Text>
                    <strong>Survival</strong>
                </Text>
                <Text>
                    The respective indemnities, representations, warranties and
                    agreements of the parties hereto or made by or on behalf of
                    the parties hereto pursuant to this Agreement will survive
                    the termination of this Agreement indefinitely and will
                    remain in full force and effect and all defined terms used
                    therein will survive the termination of this Agreement
                    indefinitely.
                </Text>
                <Text>
                    <strong>Contact Us</strong>
                </Text>
                <Text center>
                    If you would like to contact us for any reason, please reach
                    us at contact@loveplates.com.
                </Text>
            </div>
            <Footer />
        </>
    )
}
